var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.compiledTemplate != null)?_c('span',{key:_vm.$root.$children[0].viewListComponentKey},[_c(_vm.compiledTemplate,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }